import { render, staticRenderFns } from "./questionnaireRecords.vue?vue&type=template&id=d812ac78&scoped=true"
import script from "./questionnaireRecords.vue?vue&type=script&lang=js"
export * from "./questionnaireRecords.vue?vue&type=script&lang=js"
import style0 from "./questionnaireRecords.vue?vue&type=style&index=0&id=d812ac78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d812ac78",
  null
  
)

export default component.exports